import {Injectable} from '@angular/core';
import {SlackService} from '../../api/slack/slack.service';
import {environment} from '../../../../environments/environment';
import {first} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable()
export class ErrorHandlerService {
  environment = environment.environment || 'PROD';
  lastErrorMessage;

  constructor(
    private slackService: SlackService,
    private router: Router
  ) {
  }

  handleJavascriptError(error) {
    if (this.lastErrorMessage !== this.getClientMessage(error) && this.environment.indexOf('Local') === -1) {
      this.sendToSlack(error);
    }
    throw error;

    /*if (this.environment === 'PROD') {
      throw error;
    } else {
      console.error('An error occurred in Lina that probably resulted in a crash or that the action did not execute, please contact support, note what time the error occurred.');
    }*/
  }

  getClientMessage(error: Error): string {
    if (!navigator.onLine) {
      return 'No Internet Connection';
    }
    return error.message ? error.message : error.toString();
  }

  getClientStack(error: Error): string {
    return error.stack;
  }

  sendToSlack(error) {
    this.lastErrorMessage = this.getClientMessage(error);
    this.slackService.postToLinaFrontendErrors({Environment: this.environment, Url: this.router.url, Title: this.getClientMessage(error), Message: this.getClientStack(error)}).pipe(first()).subscribe(() => {});
  }
}
